// Visual indicator of agent confidence on a draft.

interface Props {
  confidence?: number | null; // 0-1
  size?: "sm" | "md";
}

export function ConfidenceBadge({ confidence, size = "sm" }: Props) {
  if (confidence === null || confidence === undefined) return null;

  const pct = Math.round(confidence * 100);
  let color = "text-status-cold ring-status-cold/30 bg-status-cold/10";
  let label = "Faible";
  if (confidence >= 0.8) {
    color = "text-status-qualified ring-status-qualified/30 bg-status-qualified/10";
    label = "Élevée";
  } else if (confidence >= 0.55) {
    color = "text-status-qualifying ring-status-qualifying/30 bg-status-qualifying/10";
    label = "Moyenne";
  } else {
    color = "text-status-disqualified ring-status-disqualified/30 bg-status-disqualified/10";
    label = "Faible";
  }

  const padding = size === "md" ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[11px]";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full ${padding} font-medium ring-1 ${color}`}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full animate-pulse-soft rounded-full bg-current opacity-75"></span>
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-current"></span>
      </span>
      <span className="tabular-nums">{pct}%</span>
      <span className="opacity-70">· {label}</span>
    </span>
  );
}

export function LowConfidenceBanner({ confidence }: { confidence?: number | null }) {
  if (confidence === null || confidence === undefined || confidence >= 0.55) return null;
  return (
    <div className="flex items-start gap-3 rounded-lg border border-status-disqualified/30 bg-status-disqualified/5 px-4 py-3 text-sm text-status-disqualified">
      <span className="text-base">🚨</span>
      <div className="flex-1">
        <div className="font-semibold">Confiance faible — review carefully</div>
        <div className="text-xs opacity-80">
          L'agent n'est pas sûr de cette réponse ({Math.round(confidence * 100)}%). Vérifie le ton et le contexte avant d'envoyer.
        </div>
      </div>
    </div>
  );
}
